import React, { useEffect, useState } from "react";
import { FaToggleOn, FaToggleOff } from "react-icons/fa6";
import { toast } from "react-toastify";
import "../../pages/user/css/Perfil.css";
import { API_BASE_URL } from "../../config/apiConfig";

const ActivarDesactivar = ({ status, userId }) => {
  const [perfilActivo, setPerfilActivo] = useState(null);

  /* Sincroniza estado inicial cuando reciba prop */
  useEffect(() => {
    if (typeof status === "string") {
      setPerfilActivo(status.toLowerCase() === "activo");
    }
  }, [status]);

  /* Llamada al backend y actualización local */
  const updateBackend = async (nuevoEstado) => {
    if (!userId) {
      toast.error("No se encontró userId");
      return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/${userId}/cambiarEstado`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estadoUsuario: nuevoEstado ? "Activo" : "Inactivo",
        }),
      });
      if (!res.ok) throw new Error();

      setPerfilActivo(nuevoEstado);
      toast.success("Estado actualizado correctamente");
    } catch {
      toast.error("Error al cambiar el estado");
    }
  };

  /** Cambio */
  const handleTogglePerfil = () => updateBackend(!perfilActivo);

  /* Espera al estado inicial antes de imprimir */
  if (perfilActivo === null) return null;

  return (
    <div className="activar column gap-30">
      <div className="between gap-50">
        <div>
          <h3 className="verde">
            {perfilActivo
              ? "Dejar mi perfil como inactivo"
              : "Reactivar mi perfil"}
          </h3>
          <p>
            Deja tu perfil inactivo cuando no necesites usar Pasaporte Hacia el
            Empleo. Podrás reactivarlo en cualquier momento.
          </p>
        </div>

        {/* Usa un button para garantizar accesibilidad y capturar el click */}
        <button
          type="button"
          className="toggle-icon"
          onClick={handleTogglePerfil}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          {perfilActivo ? (
            <FaToggleOn size={32} className="verde" />
          ) : (
            <FaToggleOff size={32} color="#8E151D" />
          )}
        </button>
      </div>
    </div>
  );
};

export default ActivarDesactivar;
